/* eslint-disable @typescript-eslint/no-empty-interface */
import React, { useState } from 'react';
import { Loader } from 'src/components';
import { VendorManagementViewRendererProps } from '../../types';

function Desktop(props: VendorManagementViewRendererProps) {
  console.log(props);
  const accountsUrl = process.env.REACT_APP_AUTH_DOMAIN;
  const [isLoading, setIsLoading] = useState(true);

  const handleLoad = () => {
    setIsLoading(false);
  };

  return (
    <div className="relative w-full h-screen flex justify-center items-center">
      {isLoading && (
        <div className="absolute inset-0 flex justify-center items-center bg-white bg-opacity-80 z-10">
          <Loader />
        </div>
      )}
      <iframe
        src={`${accountsUrl}/vendor-management`}
        title="Vendor Management"
        className="w-full h-screen border-none"
        onLoad={handleLoad}
      />
    </div>
  );
}

export default Desktop;
